import React from 'react';

const items = [
  '1+1 Standart Daire',
  '2+1 Aile Dairesi',
  '7/24 Resepsiyon',
  'Ücretsiz Wi-Fi',
  'Merkezi Konum',
  'Günlük Temizlik',
  'Zengin Kahvaltı',
];

const Diamond = () => (
  <span className="inline-block w-1.5 h-1.5 rotate-45 bg-yellow-500 mx-8 shrink-0" aria-hidden="true" />
);

const MarqueeRow = () => (
  <div className="flex items-center shrink-0">
    {items.map((item, i) => (
      <React.Fragment key={i}>
        <span className="text-sm md:text-base tracking-[0.35em] text-zinc-500 uppercase whitespace-nowrap font-medium">
          {item}
        </span>
        <Diamond />
      </React.Fragment>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <div
      className="relative bg-black border-y border-zinc-900 py-6 overflow-hidden"
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <MarqueeRow />
        <MarqueeRow />
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent pointer-events-none" />
    </div>
  );
};

export default Marquee;
